<script setup>
  import { reactive, toRefs, onMounted, watch } from 'vue'
  import {
    exportPersonalTranslateFiles,
    getDocExportCacheList,
  } from '../../../../http/api'

  let props = defineProps({
    loadingVisible: Boolean,
    fileType: Number,
    columnDetail: Object,
  })

  const state = reactive({
    status: 1,
    timeout: null,
  })

  let emits = defineEmits(['update:loadingVisible'])

  const closeFunc = () => {
    clearTimeout(state.timeout)
    emits('update:loadingVisible', false)
  }

  const refreshFunc = async (id) => {
    try {
      clearTimeout(state.timeout)
      const res = await getDocExportCacheList({
        ids: id,
      })
      const data = res.data.data
      if (data[0].exportStatus == -1) {
        state.status = 2
        message.error('导出失败')
        return
      }
      if (data[0].exportStatus == 2) {
        clearTimeout(state.timeout)
        const fileUrl = data[0].fileUrl
        if (fileUrl) {
          const ele = document.createElement('a')
          ele.setAttribute('href', fileUrl)
          ele.click()
        }
        closeFunc()
        return
      }
      state.timeout = setTimeout(() => {
        refreshFunc(id)
      }, 2000)
    } catch (error) {
      state.status = 2
      clearTimeout(state.timeout)
    }
  }

  const getExportPersonalTranslateFiles = () => {
    let params = {
      fileType: props.fileType,
      taskIds: props.columnDetail.taskId,
    }

    //针对99做单独处理，99是图片导出选择可编辑译图
    if (props.fileType == 99) {
      params.fileType = 1
      params.imageSaveType = 3
    }
    state.status = 1
    exportPersonalTranslateFiles(params).then((res) => {
      const data = res.data.data
      if (data) {
        refreshFunc(data)
      }
    })
  }

  onMounted(() => {
    // ()
  })

  watch(
    () => props.loadingVisible,
    (n) => {
      if (n) {
        getExportPersonalTranslateFiles()
      }
    }
  )

  const { status } = toRefs(state)
</script>

<template>
  <a-modal
    :visible="loadingVisible"
    :footer="null"
    :bodyStyle="{ padding: '0' }"
    title="导出"
    centered
    wrapClassName="loading-modal"
    @cancel="closeFunc"
  >
    <div>
      <div
        v-if="status == 1"
        class="display-flex flex-column flex-center padding-t-40"
      >
        <a-button shape="circle" loading class="loading-btn" />
        <p
          class="color-333 padding-t-10 padding-b-5 font-weight-600 font-size-18"
        >
          正在生成文件…
        </p>
        <p class="color-999 font-size-14 padding-b-40">生成后将自动下载</p>
      </div>
      <div v-else class="display-flex flex-column flex-center">
        <div class="icon-fail">
          <img src="../../../../images/export-fail.png" alt="" />
        </div>
        <p class="color-333 padding-b-5 font-weight-600 font-size-18">
          导出失败
        </p>
        <p class="color-999 font-size-14 padding-b-40">请重试</p>
      </div>
      <div class="loading-footer">
        <a-button @click="closeFunc">取消</a-button>
        <a-button
          type="primary"
          @click="getExportPersonalTranslateFiles"
          v-if="status == 2"
          class="margin-l-10"
        >
          重试
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<style lang="scss">
  .loading-modal {
    .ant-modal {
      width: 560px !important;
    }
  }
</style>
<style lang="scss" scoped>
  .loading-btn {
    width: 56px;
    height: 56px;
    color: var(--primary-color);
    background: #fff;
    border: none;
    text-shadow: none;
    box-shadow: none;
  }
  :deep(.ant-btn-icon-only > *) {
    font-size: 56px;
  }
  .close-box {
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    &:hover {
      background: #f2f3f5;
      cursor: pointer;
    }
    .icon {
      width: 8px;
      height: 8px;
    }
  }
  .icon-fail {
    width: 124px;
    height: 124px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .loading-footer {
    display: flex;
    justify-content: flex-end;
    padding: 12px 20px;
    box-shadow:
      0px 4px 20px 0px rgba(0, 0, 0, 0.1),
      inset 0px 1px 0px 0px #eeeeee;
    border-radius: 0px 0px 8px 8px;
  }
</style>
